import React from 'react'
import Navbar from '../components/Reset/Navbar'
import Main from '../components/Reset/Main'
import '../css/reset.css'

class Reset extends React.Component {
	render() {
		return (
			<div>
				<Navbar />
				<Main />
			</div>
		)
	}
}

export default Reset


// WEBPACK FOOTER //
// ./src/containers/Reset.js